import cls from 'classnames';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeNotification } from './actions';
import selector from './selector';
import useStyles from './styles';

interface Props {
}

const Notification: React.FC<Props> = () => {
  const { show, type, message } = useSelector(selector);
  const dispatch = useDispatch();
  const classes = useStyles();

  useEffect(() => {
    if (show) {
      setTimeout(() => {
        dispatch(closeNotification());
      }, 3000);
    }
  }, [show]);

  return (
    <div className={cls(
      classes.root,
      { [classes.rootVisible]: show },
    )}>
      {type && (
        <>
          <img src={type === 'success' ? '/img/root/success.svg' : '/img/root/error.svg'} />
          <p className={classes[type]}>{type === 'success' ? 'Success.' : 'Ooooops.'}</p>
        </>
      )}
      <p>{message}</p>
    </div>
  );
};

export default Notification;
